import { css, cssManager } from '@design.estate/dees-element';
import { themeDefaultStyles } from '../00theme.js';

export const kanbanStyles = [
  themeDefaultStyles,
  cssManager.defaultStyles,
  css`
    :host {
      display: block;
      min-width: 0;
      font-family: var(--dees-font-family);
      color: var(--dees-color-text-primary);
      font-size: var(--dees-font-subhead-size);
      line-height: 1.5;
    }

    * {
      box-sizing: border-box;
    }

    h2,
    h3,
    p {
      margin: 0;
    }

    .muted {
      color: var(--dees-color-text-secondary);
    }

    .caption {
      font-size: var(--dees-font-footnote-size);
      color: var(--dees-color-text-secondary);
    }

    .error {
      color: var(--dees-color-text-error);
      padding: 10px 0;
      font-size: var(--dees-font-footnote-size);
    }

    .empty {
      padding: 24px 12px;
      text-align: center;
      color: var(--dees-color-text-secondary);
      font-size: var(--dees-font-footnote-size);
    }

    .row {
      display: flex;
      gap: 8px;
      align-items: center;
      flex-wrap: wrap;
    }

    .spacer {
      flex: 1;
    }

    button.link {
      border: 0;
      background: transparent;
      font: inherit;
      color: var(--dees-color-link);
      padding: 2px 0;
      text-align: left;
      cursor: pointer;
      overflow-wrap: anywhere;
    }

    button:focus-visible,
    summary:focus-visible {
      outline: 2px solid var(--dees-color-focus-ring);
      outline-offset: 3px;
      border-radius: var(--dees-radius-sm);
    }

    dees-icon {
      font-size: 16px;
    }

    .badge {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      background: var(--dees-color-fill-tertiary);
      padding: 3px 7px;
      border-radius: var(--dees-radius-sm);
      font-size: var(--dees-font-caption1-size);
      color: var(--dees-color-text-secondary);
    }

    .avatar {
      flex: 0 0 auto;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: var(--dees-color-fill-secondary);
      color: var(--dees-color-text-secondary);
      display: inline-grid;
      place-items: center;
      font-size: 10px;
      font-weight: 600;
      line-height: 1;
    }

    .priority {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      font-size: var(--dees-font-caption1-size);
      color: var(--dees-color-text-secondary);
      text-transform: capitalize;
    }

    .priority[data-priority=urgent] {
      color: var(--dees-color-text-error);
    }

    .priority[data-priority=high] {
      color: var(--dees-color-text-warning);
    }

    .priority dees-icon {
      font-size: 13px;
    }

    .section-title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 10px;
    }

    .section-title h3 {
      font-size: var(--dees-font-footnote-size);
      font-weight: 600;
    }

    .count {
      display: inline-grid;
      place-items: center;
      min-width: 20px;
      height: 20px;
      padding: 0 5px;
      border-radius: var(--dees-radius-sm);
      background: var(--dees-color-fill-tertiary);
      color: var(--dees-color-text-secondary);
      font-size: var(--dees-font-caption1-size);
      font-weight: 500;
      font-variant-numeric: tabular-nums;
    }
  `,
];
